<template>
  <div class="Main">
	<van-tabbar v-model="active" active-color="#0c34ba" route>
	  <van-tabbar-item v-for="(item,index) in tabbarData" :key="index" :to="item.url">
	    <span>{{item.titie}}</span>
	    <template #icon="props">
	      <img :src="props.active ? item.icon.active : item.icon.inactive" />
	    </template>
	  </van-tabbar-item>
	</van-tabbar>
	
	
	
    <div>
      <!-- 二级路由插座, 展示二级路由组件 -->
	  <keep-alive include="Home,Menu">
		  <router-view></router-view>
	  </keep-alive>
    </div>
  </div>
</template>

<script>
  export default {
	  data() {
      return {
		active: 0,
		tabbarData:[
			{
			titie: '首页',
			icon: 
				{
				active: require('../assets/images/tabbar_18.png'),
				inactive: require('../assets/images/tabbar_03.png')
				},
			url:
				{
				name: 'Home'
				}	
			},
			{
			titie: '菜单',
			icon: 
				{
				active: require('../assets/images/icons_18.gif'),
				inactive: require('../assets/images/icons_03.gif')
				},
			url:
				{
				name: 'Menu'
				}
			},
			{
			titie: '购物袋',
			icon: 
				{
				active: require('../assets/images/tabbar_21.png'),
				inactive: require('../assets/images/tabbar_09.png')
				},
			url:
				{
				name: 'Shopbag'
				}		
			},
			{
			titie: '我的',
			icon: 
				{
				active: require('../assets/images/tabbar_22.png'),
				inactive: require('../assets/images/tabbar_11.png')
				},
			url:
				{
				name: 'My'
				}		
			}
		]
      }
    }
	
  }
</script>
<style lang="less" scoped>
  
</style>